import { gridPaginationSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';
import { FC, useMemo, useCallback } from 'react';
import { TablePagination } from '../tables/presentation/table/pagination';

export const TableDataGridPagination: FC = () => {
  const apiRef = useGridApiContext();
  const paginationState = useGridSelector(apiRef, gridPaginationSelector);
  const lastPage = useMemo(
    () => Math.floor(paginationState.rowCount / (paginationState.pageSize || 1)),
    [paginationState.rowCount, paginationState.pageSize]
  );

  const page = paginationState.page <= lastPage ? paginationState.page : lastPage;

  const handlePageSizeChange: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement> =
    useCallback(
      (event) => {
        const newPageSize = Number(event.target.value);
        apiRef.current.setPageSize(newPageSize);
      },
      [apiRef]
    );
  const handlePageChange = useCallback(
    (event: React.MouseEvent<HTMLButtonElement> | null, changedPage: number) => {
      apiRef.current.setPage(changedPage);
    },
    [apiRef]
  );

  return (
    <TablePagination
      onRowsPerPageChange={handlePageSizeChange}
      count={paginationState.rowCount}
      onPageChange={handlePageChange}
      page={page}
      rowsPerPage={paginationState.pageSize}
    />
  );
};
